<template>
    <div class="padding-15" style="height: 50vh; overflow: auto">
        <Timeline v-if="detailList.length > 0">
            <TimelineItem v-for="(item, index) in detailList" :key="index"
                ><div>
                    {{ item.city || "--" }},{{ item.state || "--" }},{{
                        item.country || "--"
                    }},{{ item.status || "--" }},{{ item.statusDetail || "--" }}
                </div>
                <div>{{ item.datetime || "--" }}</div></TimelineItem
            >
        </Timeline>
        <div v-else class="text-center">
            {{
                $t("erp.b2c.no_data_available", { defaultValue: "暂无数据..." })
            }}
        </div>
    </div>
</template>

<script>
import { HttpLabelDifferenceDetail } from "@/service/boss/b2corder";
export default {
    props: ["trackNo"],
    data() {
        return {
            detailList: [],
        };
    },
    created() {
        // this.detailList = JSON.parse(this.trackDetail || null) || []
        this.getLabelDetail();
    },
    methods: {
        async getLabelDetail() {
            this.loading = true;
            await HttpLabelDifferenceDetail({
                trackingNo: this.trackNo,
            }).then(
                (res) => {
                    this.detailList =
                        JSON.parse(res.data.trackDetail || null) || [];
                },
                (err) => {
                    this.loading = false;
                    this.$Message.error(err.message);
                }
            );
        },
    },
};
</script>
